import {isVersionHigher} from 'env';
import {extractSavedVersion} from 'setup/extractSavedVersion';
import {BREAKING_VERSION} from './const';

export function shouldUpgrade(): boolean {
  const savedVersion = extractSavedVersion();
  return isVersionHigher(BREAKING_VERSION, savedVersion);
}
